import { render } from "./Reagieren.vue?vue&type=template&id=4c75a89e&scoped=true"
import script from "./Reagieren.vue?vue&type=script&lang=js"
export * from "./Reagieren.vue?vue&type=script&lang=js"

import "./Reagieren.vue?vue&type=style&index=0&id=4c75a89e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c75a89e"]])

export default __exports__